<template>
    <Evaluation/>
</template>
<script>
import Evaluation from 'place/evaluation/evaluation.vue'
export default {
    components:{
        Evaluation
    }
}
</script>
t